import { Component, forwardRef, ChangeDetectionStrategy, Input, ChangeDetectorRef, inject }
    from '@angular/core';
import {NG_VALUE_ACCESSOR, ControlValueAccessor, FormsModule} from '@angular/forms';

@Component({
    selector: 'app-checkbox',
    templateUrl: './checkbox.component.html',
    styleUrls: ['./checkbox.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CheckboxComponent),
            multi: true
        }
    ],
    imports: [
        FormsModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckboxComponent implements ControlValueAccessor {
    private readonly changeDetectorRef = inject(ChangeDetectorRef);

    public get value() {
        return this._value;
    }

    @Input()
    public set value(value) {
        this._value = value;
        this._onChange(value);
        this._onTouched(value);
    }
    @Input() id: string;
    @Input() disable: boolean;

    private _value: boolean;

    public registerOnChange(fn: any): void {
        this._onChange = fn;
    }

    public registerOnTouched(fn: any): void {
        this._onTouched = fn;
    }

    public writeValue(value: boolean): void {
        if (value !== null) {
            this.value = value;
            this.changeDetectorRef.detectChanges();
        }
    }

    private _onChange: any = () => {};
    private _onTouched: any = () => {};
}
